import ProfileAccount from '@/screens/ProfileAccount';

export default function PrivateProfileAccountIndexRoute() {
  return <ProfileAccount />;
}
